import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
	rejectKazooInvitationUser,
	rejectKazooInvitationVendor,
} from '../../features/kazooEventSlice'
import { toastHelper } from '../../util/toastHelper'
import CommonModal from '../atoms/modal/CommonModal'
import ButtonCustom from '../atoms/button/ButtonCustom'
import InputCustom from '../atoms/input/InputCustom'

// A popup modal that asks the user to confirm leaving the wedding
export const LeaveKazooPopup = ({
	popupToggle,
	clickHandler,
	userId,
	kazooId,
}) => {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const [reason, setReason] = useState('')

	const accountType = useSelector((s) => s.auth.accountType)

	const handleRemove = () => {
		if (!reason || !reason.trim())
			return toastHelper('Please enter a reason', 'error')
		if (accountType === 'user') {
			dispatch(rejectKazooInvitationUser({ userId, kazooId, reason }))
		} else if (accountType === 'vendor') {
			dispatch(
				rejectKazooInvitationVendor({
					vendorId: userId,
					kazooId,
					reason,
				})
			)
		} else if (accountType === 'kazoo-planner') {
			/* TODO: Implement rejectKazooInvitationKazooPlanner */
			return toastHelper('Not yet implemented', 'error')
		} else {
			return toastHelper('Invalid account type', 'error')
		}
		clickHandler()
		navigate('/user-dashboard', { replace: true })
	}

	return (
		<CommonModal
			open={popupToggle}
			handleClose={clickHandler}
			heading={"Are you sure you want to leave this wedding event?"}
			subHeading={"This action is permanent and cannot be undone."}
			footerContent={
				<>
					<ButtonCustom
						variant="outlined"
						type="button"
						size="lg"
						onClick={clickHandler}
					>
						Cancel
					</ButtonCustom>
					<ButtonCustom
						variant="destructive"
						size="lg"
						onClick={handleRemove}
						disabled={!reason}
						data-cy="leave-wedding-confirm"
					>
						Leave
					</ButtonCustom>
				</>
			}
		>
			<InputCustom
				value={reason}
				onChange={(e) => setReason(e.target.value)}
				type="text"
				placeholder="Please enter reason"
				sx={{
					'& .MuiFormHelperText-root': {
						position: 'absolute',
						bottom: '20px',
					},
				}}
			/>
		</CommonModal>
	)
}
